import { ReactElement } from 'react';

import { PatientAddressUpdateCommand } from '@dreryk/egabinet-patient-frontend-api';
import { PatientId } from '@dreryk/egabinet-patient-published-language-api';
import { PartialAddress } from '@dreryk/address-common-api';
import { VisitQuery } from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';
import { commonTranslationKeys } from '@dreryk/react-common';

import { PatientAddressFormBean, PatientAddressFormController } from '../form/PatientAddressForm.types';
import { draftPrescriptionsTranslationKeys } from '../../../../../../translations';

type PatientAddressModalConfirmButtonProps = Pick<PatientAddressFormController, 'handleSubmit'> & {
   patientId: number;
   onSuccess: VoidFunction;
};

export const PatientAddressModalConfirmButton = (props: PatientAddressModalConfirmButtonProps): ReactElement => {
   const { executeAsync: updatePatientAddress } = useCqrsCommand<void, PatientAddressFormBean>(
      (parameters) => {
         const command = new PatientAddressUpdateCommand();
         command.id = PatientId.of(props.patientId);
         command.address = PartialAddress.builder()
            .withTown(parameters.town)
            .withBuilding(parameters.building)
            .withCountry(parameters.country)
            .withPostcode(parameters.postcode)
            .withFlat(parameters.flat)
            .withStreet(parameters.street)
            .build();

         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(draftPrescriptionsTranslationKeys.patientAddressSuccessfullyUpdated);
            refetchCqrsQuery(VisitQuery);
            props.onSuccess();
         },
      }
   );

   return <ModalConfirmButton label={commonTranslationKeys.save} onClick={props.handleSubmit(updatePatientAddress)} />;
};
